import { JuniperEmailLayout } from './layouts/JuniperEmailLayout';
import { JuniperEmailReportView } from './components/JuniperEmailReportView';

export function JuniperEmailDashboardPage() {
  return (
    <JuniperEmailLayout>
      <JuniperEmailReportView />
    </JuniperEmailLayout>
  );
}
